import React from "react";
import { t } from "i18next";

import addIcon from '../../../assets/icons/add.svg';
import deleteIcon from '../../../assets/icons/delete.svg';

import Loading from "../../../common/components/Loading.js";

function ContactInfoForm({
    userData,
    additionalPhones,
    phoneErrors,
    handlePhoneChange,
    handleDeletePhone,
    handleAddPhone,
    onPublish,
    onPreview,
    isLoading,
}) {
    return (
        <div className="contact_info">
            <h4 className="section_heading">{t('your_data')}</h4>

            <div className="contact_section">
                <label className="input_label">{t('contact_name')}</label>
                <input
                    type="text"
                    className="input_field"
                    contentEditable={false}
                    value={userData?.name || t('default_value')}
                    disabled
                />
            </div>

            <div className="phone_section">
                <label className="input_label">{t('phone')}</label>
                <input
                    type="tel"
                    className="input_field"
                    contentEditable={false}
                    value={userData?.phone_number || t('default_value')}
                    disabled
                />
                {additionalPhones.map((phone, index) => (
                    <div key={index} className="address_item">
                        <input
                            type="tel"
                            className={`input_field ${phoneErrors[index] ? 'error' : ''}`}
                            placeholder={t('enter_additional_phone')}
                            value={phone}
                            onChange={(e) => handlePhoneChange(index, e.target.value)}
                        />
                        <img src={deleteIcon} alt={t('delete')} className="click" onClick={() => handleDeletePhone(index)} />
                        {phoneErrors[index] && (
                            <span className="error_text">{t('enter_phone')}</span>
                        )}
                    </div>
                ))}
                <button className="add_phone_button click" onClick={handleAddPhone}>
                    <img src={addIcon} alt={t('add')} /> <span className="tel_add_button_text">{t('add_more')}</span>
                </button>
            </div>

            <div className="title_section mobile_show">
                <button
                    className="ad_form_buttons publish_button"
                    onClick={onPublish}
                    disabled={isLoading}
                >
                    {isLoading ? <Loading /> : t('publish')}
                </button>
                <button
                    className="ad_form_buttons review_button"
                    disabled={isLoading}
                    onClick={onPreview}
                >
                    {t('preview')}
                </button>
            </div>
        </div>
    );
}

export default ContactInfoForm;